module.exports = __webpack_public_path__ + "img/dracula-22.bff701d6.jpg";